document.addEventListener('click', function (event) {
  var minus = event.target.closest('[data-quantity-minus]');
  var plus = event.target.closest('[data-quantity-plus]');
  if (!minus && !plus) return;
  var wrapper = event.target.closest('[data-quantity-wrapper]');
  if (!wrapper) return;
  var input = wrapper.querySelector('input[type="number"]');
  if (!input) return;
  var value = parseInt(input.value, 10) || 1;
  var min = input.min !== '' ? parseInt(input.min, 10) : 1;
  if (minus) value = Math.max(min, value - 1);
  if (plus) value = value + 1;
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('form.product-form');
  if (!form) return;
  event.preventDefault();

  var submitButton = form.querySelector('[data-product-form-submit]');
  var formData = new FormData(form);

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.dataset.originalText = submitButton.dataset.originalText || submitButton.textContent;
    submitButton.textContent = submitButton.dataset.loadingText || submitButton.textContent;
  }

  fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: formData,
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    })
    .then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } });
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      updateCartHeaderCount(cart);
      if (submitButton) {
        submitButton.textContent = submitButton.dataset.addedText || submitButton.dataset.originalText;
        setTimeout(function () {
          submitButton.textContent = submitButton.dataset.originalText;
          submitButton.disabled = false;
        }, 1600);
      }
    })
    .catch(function (error) {
      if (submitButton) {
        submitButton.textContent = submitButton.dataset.originalText;
        submitButton.disabled = false;
      }
      var message = (error && error.description) || 'Something went wrong. Please try again.';
      var errorEl = form.querySelector('[data-product-form-error]');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
    });
});

function normalizeOptionValue(value) {
  return (value || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
}

function formatMoney(cents) {
  var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  var amount = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return format.replace(/\{\{\s*amount\s*\}\}/, amount);
}

document.addEventListener('change', function (event) {
  var form = event.target.closest('form.product-form');
  if (!form || event.target.type !== 'radio') return;

  var variantScript = form.querySelector('[data-product-variants]');
  if (!variantScript) return;
  var variants;
  try {
    variants = JSON.parse(variantScript.textContent);
  } catch (e) {
    return;
  }

  var selectedOptions = Array.from(form.querySelectorAll('.product-form__option')).map(function (fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });

  var match = variants.find(function (variant) {
    var variantOptions = [variant.option1, variant.option2, variant.option3];
    return selectedOptions.every(function (value, index) {
      return value === null || normalizeOptionValue(value) === normalizeOptionValue(variantOptions[index]);
    });
  });

  var infoWrapper = form.closest('.product-main__info');
  var idInput = form.querySelector('[data-variant-id]');
  var submitButton = form.querySelector('[data-product-form-submit]');
  var priceEl = infoWrapper ? infoWrapper.querySelector('[data-price]') : null;
  var comparePriceEl = infoWrapper ? infoWrapper.querySelector('[data-compare-price]') : null;
  var mainImage = document.getElementById('ProductMainImage');

  if (!match) {
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = submitButton.dataset.unavailableText || submitButton.textContent;
    }
    return;
  }

  if (idInput) idInput.value = match.id;

  if (priceEl && match.price != null) {
    priceEl.textContent = formatMoney(match.price);
  }
  if (comparePriceEl) {
    if (match.compare_at_price != null && match.compare_at_price > match.price) {
      comparePriceEl.textContent = formatMoney(match.compare_at_price);
      comparePriceEl.hidden = false;
    } else {
      comparePriceEl.hidden = true;
    }
  }

  if (mainImage && match.featured_image && match.featured_image.src) {
    mainImage.src = match.featured_image.src;
    mainImage.removeAttribute('srcset');
  }

  if (window.history && window.history.replaceState) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }

  if (submitButton) {
    submitButton.dataset.originalText = match.available
      ? (submitButton.dataset.addToCartText || submitButton.dataset.originalText)
      : submitButton.dataset.soldOutText;
    submitButton.disabled = !match.available;
    submitButton.textContent = submitButton.dataset.originalText;
  }
});

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  var nav = document.querySelector('[data-site-nav]');
  if (!nav) return;
  var isOpen = nav.classList.toggle('site-nav--open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

function formatItemCount(count) {
  return count === 1 ? count + ' item' : count + ' items';
}

function updateCartHeaderCount(cart) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = formatItemCount(cart.item_count);
    el.hidden = cart.item_count === 0;
  });
}

function refreshCartSection() {
  var url = window.location.pathname + (window.location.pathname.indexOf('?') === -1 ? '?' : '&') + 'section_id=main-cart';
  return fetch(url, { headers: { Accept: 'text/html' } })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('[data-cart-section]');
      var currentSection = document.querySelector('[data-cart-section]');
      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }
    });
}

function changeCartLine(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity }),
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    })
    .then(function (cart) {
      updateCartHeaderCount(cart);
      return refreshCartSection();
    });
}

document.addEventListener('change', function (event) {
  var input = event.target.closest('[data-cart-quantity-input]');
  if (!input) return;
  var item = input.closest('[data-cart-item]');
  if (!item) return;
  var key = item.dataset.key;
  var quantity = Math.max(0, parseInt(input.value, 10) || 0);
  item.setAttribute('aria-busy', 'true');
  changeCartLine(key, quantity).catch(function () {
    item.removeAttribute('aria-busy');
  });
});

document.addEventListener('click', function (event) {
  var removeLink = event.target.closest('[data-cart-remove]');
  if (!removeLink) return;
  event.preventDefault();
  var item = removeLink.closest('[data-cart-item]');
  if (!item) return;
  var key = item.dataset.key;
  item.setAttribute('aria-busy', 'true');
  changeCartLine(key, 0).catch(function () {
    item.removeAttribute('aria-busy');
  });
});
